import * as React from "react";

import { createAvatar } from "@dicebear/core";
import * as style from "@dicebear/identicon";

import classNames from "classnames";

type Props = {
  identity: string;
  className?: string;
};

const Identicon: React.FunctionComponent<Props> = ({ identity, className }) => {
  const svg = createAvatar(style, {
    seed: identity,
    backgroundColor: ["#fff"],
    rowColor: [
      "00acc1",
      "1e88e5",
      "5e35b1",
      "6d4c41",
      "7cb342",
      "43a047",
      "546e7a",
      "00897b",
      "c0ca33",
    ],
  });
  return (
    <div
      className={classNames("w-3 h-3", className)}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export default Identicon;
